webpackJsonp([49703325968905],{

/***/ 1857:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MedicationIntegrationTransactionEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"MedicationIntegrationTransaction","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-medication-integration-transaction-edge-741ccd3a431d5d75d288.js